import { Symbol } from "@/components/fornada/brand";
import { cn } from "@/lib/utils";

const Loader = ({ className }: { className?: string }) => (
  <div
    className={cn(
      "flex h-screen w-full items-center justify-center",
      className,
    )}
  >
    <Symbol size={44} className="fx-pulse" />
  </div>
);

interface ContentLoaderProps {
  show: boolean;
  title?: string;
}
const ContentLoader: React.FC<ContentLoaderProps> = ({
  show = false,
  title = "Carregando",
}) => {
  if (!show) return null;

  return (
    <div
      role="status"
      aria-label={title}
      className="fixed inset-0 z-90 flex items-center justify-center bg-fx-scrim backdrop-blur-sm"
    >
      <Symbol size={44} className="fx-pulse" />
    </div>
  );
};

export { ContentLoader, Loader };
